// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18zrze3t{padding-inline:var(--ds-space-0,0)}
._1rjcze3t{padding-block:var(--ds-space-0,0)}
._1e0c1bgi{display:contents}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/smart-card/dist/esm/view/FlexibleCard/components/actions/unresolved-action/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,kCAAkC;AAC7C,WAAW,iCAAiC;AAC5C,WAAW,gBAAgB","sourcesContent":["._18zrze3t{padding-inline:var(--ds-space-0,0)}\n._1rjcze3t{padding-block:var(--ds-space-0,0)}\n._1e0c1bgi{display:contents}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
